import {useLocation} from "react-router-dom";
import {useEffect} from "react";

export default function RouteEffects() {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo({top: 0, left: 0, behavior: "auto"});
    }, [location.pathname]);

    return null;
}
